import { ValidationArea, ValidationProblemResponse } from '@ydistri/api-sdk';
import { skipToken } from '@reduxjs/toolkit/query';
import { reportQuery, useGetValidationProblemsQuery } from '../../../apis/apiValidationProblems';
import { TemplateOrCalculationWithValue } from '../../../apis/api';
import { useTemplateOrCalculationWithValue } from '../../../hooks/useTemplateOrCalculationWithValue';

interface StoresReport {
  problems: ValidationProblemResponse[] | undefined;
  isLoading: boolean;
}

/** The stores area report of the template on screen (or the one given); one cache entry for all consumers. */
export const useStoresReport = (
  forcedTemplateOrCalculation?: TemplateOrCalculationWithValue,
): StoresReport => {
  const current = useTemplateOrCalculationWithValue();
  const templateOrCalculation = forcedTemplateOrCalculation ?? current;

  const { data, isFetching } = useGetValidationProblemsQuery(
    templateOrCalculation.hasValidValue
      ? reportQuery(
          { type: templateOrCalculation.type, id: templateOrCalculation.id },
          ValidationArea.StoresAndDepartments,
        )
      : skipToken,
  );

  return { problems: data, isLoading: isFetching };
};
